// lib/leasing/sourceBudgetProposal.ts
import type { SourceBudgetProposal } from '#types/types';
import { MANDATE_MAX_CEILING_CREDITS } from '#lib/leasing/sourcingMandate';

export const SOURCE_BUDGET_PROPOSAL_EVENT = 'SOURCE_BUDGET_PROPOSAL';
export const SOURCE_BUDGET_PROPOSAL_PREFIX = 'source-budget-proposal:';
export const isSourceBudgetProposal = (id: unknown, eventType?: unknown): boolean =>
  (typeof id === 'string' && id.startsWith(SOURCE_BUDGET_PROPOSAL_PREFIX)) || eventType === SOURCE_BUDGET_PROPOSAL_EVENT;

export const proposedCreditCeiling = (previous: number, committed: number, additional: number): number => {
  if (![previous, committed, additional].every(Number.isSafeInteger) || previous < 1 || committed < 0 || committed > previous || additional < 1) {
    throw new Error('Use a positive whole number of additional credits and a valid existing allowance.');
  }
  const total = previous + additional;
  if (total > MANDATE_MAX_CEILING_CREDITS) throw new Error(`The total credit ceiling cannot exceed ${MANDATE_MAX_CEILING_CREDITS}.`);
  return total;
};

export const readSourceBudgetProposal = (value: unknown): SourceBudgetProposal | null => {
  const p = value as SourceBudgetProposal | null;
  return p && typeof p === 'object' && !Array.isArray(p) && typeof p.id === 'string'
    && p.id.startsWith(SOURCE_BUDGET_PROPOSAL_PREFIX) && typeof p.campaignId === 'string'
    && typeof p.chatSessionId === 'string' && typeof p.goal === 'string'
    && ['pending', 'approving', 'accepted', 'declined', 'failed'].includes(p.status) ? p : null;
};
